<template>
    <div class="">
        <div class="row mt-5">
            <div class="col-sm-12">
                <a :href="$api_url+'/employee'" class="btn btn-primary rounded p-2 pr-4 pl-4 float-right"><span><b-icon icon="reply" rotate="0" flip-h="" class="mr-2" scale="2"></b-icon></span><span>Back to List</span></a>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <b-form @submit.prevent="submitForm">
                    <!-- Select Fiscal Year -->
                    <b-form-group
                        label="Select Fiscal Year"
                        label-for="fiscal-year"
                        class="mb-3 d-block required-field"
                    >
                        <b-col cols="6" class="px-0">
                            <b-form-select
                                id="fiscal-year"
                                name="fiscal_year"
                                v-model="year"
                                :options="payrunyears"
                                :state="validateState('fiscal_year')"
                                v-validate="{ required: true }"
                                data-vv-as="Fiscal Year"
                                aria-describedby="fiscal-year-feedback"
                                class="custom-select"
                            ></b-form-select>
                            <b-form-invalid-feedback id="fiscal-year-feedback">
                                {{ veeErrors.first('fiscal_year') }}
                            </b-form-invalid-feedback>
                        </b-col>
                    </b-form-group>
                    <p class="my-3">Note: File name must contain (xxxx_taxreturn.pdf) a valid employee code. Files without mathcing employee code will not be uploaded.</p>
                    <b-form-group label="Upload PDF files:" label-for="pdf-upload">
                        <b-form-file
                        id="pdf-upload"
                        v-model="files"
                        :multiple="true"
                        :accept="'.pdf'"
                        browse-text="Choose PDFs"
                        placeholder="Choose PDF files..."
                        ></b-form-file>
                    </b-form-group>

                    <b-alert
                        v-if="fileErrors.length"
                        variant="danger"
                        show
                        class="mt-2"
                    >
                        <ul>
                            <li v-for="(error, index) in fileErrors" :key="index">
                                {{ error }}
                            </li>
                        </ul>
                    </b-alert>

                    <b-list-group class="mt-3" v-if="files.length">
                        <b-list-group-item
                        v-for="(file, index) in files"
                        :key="index"
                        >
                        {{ file.name }} — {{ (file.size / 1024).toFixed(2) }} KB
                        </b-list-group-item>
                    </b-list-group>

                    <b-button type="submit" variant="primary" class="mt-3">
                        Upload
                    </b-button>
                </b-form>
            </div>

            <ul class="list-group mb-3 mt-5" v-if='errormsg'>
                <li class="list-group-item list-group-item-danger" v-for="(data, index) in errormsg" :key="index">{{data}}</li>
            </ul>
        </div>



    </div>
</template>

<script>
    export default {
        props: ['pageurl'],
        data() {
            return {
                files: [],
                fileErrors: [],
                payrunyears: [],
                year: '',
                showoverlay: false,
                errormsg:[],
            };
        },
        watch: {
            files(newFiles) {
            this.fileErrors = [];
            for (let file of newFiles) {
                if (file.type !== "application/pdf") {
                    this.fileErrors.push(`${file.name} is not a valid PDF file.`);
                }
            }
            },
        },
        methods: {
            getpayrunyears: function () {
                axios.get('/get/fiscalyear/list').then(function (response) {
                this.payrunyears = response.data;

                }.bind(this));
            },
            submitForm() {
                if(!this.checkNet()) return false;
                this.fileErrors = [];
                this.errormsg = [];
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    this.showoverlay = true;
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                    if (this.files.length === 0) {
                        this.fileErrors = ["Please select at least one valid PDF file."];
                        return;
                    }

                    const formData = new FormData();
                    formData.append("fiscal_year", this.year);

                    this.files.forEach((file, index) => {
                        formData.append("pdf_files[]", file);
                    });

                    axios.post(this.$api_url + '/upload-tax-files-bulk', formData, config)
                    .then(function (response) {
                        this.errormsg = response.data.skipped;

                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                        this.showoverlay = false;
                        // this.resetForm();

                    }.bind(this))
                    .catch(function (error) {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);

                        if (error.response && error.response.data && error.response.data.errors) {
                            currentObj.errormsg = error.response.data.errors;
                        } else if (error.message) {
                            currentObj.errormsg = { general: [error.message] };
                        } else {
                            currentObj.errormsg = { general: ['Unexpected error occurred.'] };
                        }
                    });
                });
            },
        },
        created: function () {
            this.getpayrunyears();
        },
    };
</script>
